import { Pagination } from '../ui';
import type { DashboardSection } from '../layout/Sidebar';

interface QueueFooterProps {
  section: DashboardSection;
  // Pagination
  currentPage: number;
  totalPages: number;
  pageSize: number;
  totalItems: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: number) => void;
}

export function QueueFooter({
  currentPage,
  totalPages,
  pageSize,
  totalItems,
  onPageChange,
  onPageSizeChange,
}: QueueFooterProps) {
  const showPagination = totalPages > 1;

  // Don't render if no pagination needed
  if (!showPagination) {
    return null;
  }

  return (
    <div className="flex items-center justify-end px-4 py-3 border-t border-gray-200 dark:border-dark-border bg-gray-50 dark:bg-dark-recessed rounded-b-lg">
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        pageSize={pageSize}
        totalItems={totalItems}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
      />
    </div>
  );
}
